import React from 'react';

const D2cChannelRequest = React.lazy(() => import('../../modules/account/D2cChannelRequest'));

export const d2cChannelRequestRoutesConfig = [
  {
    path: '/d2c-channel-request',
    element: <D2cChannelRequest />,
  },
];
